import { render } from "./compare-us.vue?vue&type=template&id=2ef1a314&scoped=true"
const script = {}

import "./compare-us.vue?vue&type=style&index=0&id=2ef1a314&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef1a314"]])

export default __exports__